"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SocialCreateViewContainer = SocialCreateViewContainer;
var _uiKit = require("@cian/ui-kit");
var React = _interopRequireWildcard(require("react"));
var _validation = require("../../utils/validation");
var _ViewContainer = require("../ViewContainer");
var _PhoneField = require("../../components/PhoneField");
var _InputField = require("../../components/InputField");
var _view = require("../../types/view");
var _keyCodes = require("../../types/keyCodes");
var _ContentLayout = require("../../components/ContentLayout");
var _TitleContainer = require("../TitleContainer");
var _tracking = require("../../utils/tracking");
var _FieldGroupLayout = require("../../components/FieldGroupLayout");
var _HelpContainer = require("../HelpContainer");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function SocialCreateViewContainer(_ref) {
  let {
    disabled,
    hasError,
    error,
    phone,
    email,
    source,
    reset,
    create,
    changeView,
    changeEmail,
    changePhone
  } = _ref;
  // FORM
  const [changed, setChanged] = React.useState(false);
  const [touched, setTouched] = React.useState(false);

  // EMAIL
  const [isEmailInvalid, setEmailInvalid] = React.useState(false);

  // PHONE
  const [isPhoneInvalid, setPhoneInvalid] = React.useState(false);
  const handleEmailChange = React.useCallback(e => {
    const {
      value
    } = e.currentTarget;
    setEmailInvalid(value === '' || value !== '' && !(0, _validation.isEmail)(value));
    setChanged(true);
    changeEmail(value);
  }, [changeEmail]);
  const handlePhoneChange = React.useCallback(value => {
    changePhone(value);
    setChanged(true);
    setPhoneInvalid(value === '' || value !== '' && !(0, _validation.isValidPhone)(value));
  }, [changePhone]);
  const handleSubmit = React.useCallback(() => {
    setTouched(true);
    if (disabled || isEmailInvalid || isPhoneInvalid) {
      return;
    }
    create();
    setChanged(false);
  }, [disabled, isEmailInvalid, isPhoneInvalid, create]);
  const handleCancel = React.useCallback(() => {
    reset();
    changeView(_view.EActiveView.AuthenticationRegistration);
  }, [changeView, reset]);
  React.useEffect(() => {
    (0, _tracking.trackSocialCreateShow)(source);
  }, []);
  const handlePreventSubmit = React.useCallback(e => {
    e.preventDefault();
  }, []);
  const handleSubmitOnEnter = React.useCallback(e => {
    if (e.keyCode === _keyCodes.EKeyCode.Enter) {
      handleSubmit();
    }
  }, [handleSubmit]);
  const handleHelpClick = React.useCallback(() => (0, _tracking.trackLoginNeedHelp)(source), [source]);
  return /*#__PURE__*/React.createElement(_ViewContainer.ViewContainer, null, /*#__PURE__*/React.createElement(_TitleContainer.TitleContainer, null), /*#__PURE__*/React.createElement(_ContentLayout.ContentLayout, null, /*#__PURE__*/React.createElement("form", {
    onSubmit: handlePreventSubmit
  }, /*#__PURE__*/React.createElement(_FieldGroupLayout.FormFieldGroupLayout, {
    content: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_InputField.InputField, {
      "data-name": "EmailInput",
      autoFocus: true,
      id: "social_create-email",
      name: "email",
      placeholder: "Email",
      invalid: touched && (hasError && !changed || isEmailInvalid),
      errorMessage: !changed && hasError ? error : undefined,
      value: email,
      onChange: handleEmailChange,
      onKeyDown: handleSubmitOnEnter,
      disabled: disabled
    }), /*#__PURE__*/React.createElement(_PhoneField.PhoneField, {
      id: "social_create-phone",
      name: "phone",
      placeholder: "\u0422\u0435\u043B\u0435\u0444\u043E\u043D",
      invalid: touched && (hasError && !changed || isPhoneInvalid),
      value: phone,
      onValueChange: handlePhoneChange,
      onKeyDown: handleSubmitOnEnter,
      disabled: disabled
    })),
    buttons: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_uiKit.Button, {
      "data-name": "SubmitSocialCreate",
      theme: "fill_primary",
      fullWidth: true,
      disabled: !email,
      loading: disabled,
      onClick: handleSubmit
    }, "\u0417\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u043E\u0432\u0430\u0442\u044C\u0441\u044F"), /*#__PURE__*/React.createElement(_uiKit.Button, {
      "data-name": "CancelSocialCreate",
      theme: "fill_secondary",
      fullWidth: true,
      onClick: handleCancel
    }, "\u041E\u0442\u043C\u0435\u043D\u0430"))
  }))), /*#__PURE__*/React.createElement(_HelpContainer.HelpContainer, {
    onClick: handleHelpClick
  }));
}